/**
 * Bio Links API Client
 */

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL || '';

// Helper to get auth headers
const getAuthHeaders = () => {
  const token = localStorage.getItem('token');
  const headers = { 'Content-Type': 'application/json' };
  if (token) {
    headers['Authorization'] = `Bearer ${token}`;
  }
  return headers;
};

export const bioLinksApi = {
  // CRUD
  create: async (data) => {
    const res = await fetch(`${BACKEND_URL}/api/v1/bio/pages`, {
      method: 'POST',
      headers: getAuthHeaders(),
      body: JSON.stringify(data)
    });
    return res.json();
  },

  stats: async () => {
    const res = await fetch(`${BACKEND_URL}/api/v1/bio/pages/stats`, {
      headers: getAuthHeaders()
    });
    return res.json();
  },

  list: async (params = {}) => {
    const query = new URLSearchParams(params).toString();
    const res = await fetch(`${BACKEND_URL}/api/v1/bio/pages?${query}`, {
      headers: getAuthHeaders()
    });
    return res.json();
  },

  get: async (id) => {
    const res = await fetch(`${BACKEND_URL}/api/v1/bio/pages/${id}`, {
      headers: getAuthHeaders()
    });
    return res.json();
  },

  update: async (id, data) => {
    const res = await fetch(`${BACKEND_URL}/api/v1/bio/pages/${id}`, {
      method: 'PUT',
      headers: getAuthHeaders(),
      body: JSON.stringify(data)
    });
    return res.json();
  },

  archive: async (id) => {
    const res = await fetch(`${BACKEND_URL}/api/v1/bio/pages/${id}`, {
      method: 'DELETE',
      headers: getAuthHeaders()
    });
    return res.json();
  },

  publish: async (id) => {
    const res = await fetch(`${BACKEND_URL}/api/v1/bio/pages/${id}/publish`, {
      method: 'POST',
      headers: getAuthHeaders()
    });
    return res.json();
  },

  unpublish: async (id) => {
    const res = await fetch(`${BACKEND_URL}/api/v1/bio/pages/${id}/unpublish`, {
      method: 'POST',
      headers: getAuthHeaders()
    });
    return res.json();
  },

  duplicate: async (id) => {
    const res = await fetch(`${BACKEND_URL}/api/v1/bio/pages/${id}/duplicate`, {
      method: 'POST',
      headers: getAuthHeaders()
    });
    return res.json();
  },

  // Links
  addLink: async (bioId, data) => {
    const res = await fetch(`${BACKEND_URL}/api/v1/bio/pages/${bioId}/links`, {
      method: 'POST',
      headers: getAuthHeaders(),
      body: JSON.stringify(data)
    });
    return res.json();
  },

  updateLink: async (bioId, linkId, data) => {
    const res = await fetch(`${BACKEND_URL}/api/v1/bio/pages/${bioId}/links/${linkId}`, {
      method: 'PUT',
      headers: getAuthHeaders(),
      body: JSON.stringify(data)
    });
    return res.json();
  },

  deleteLink: async (bioId, linkId) => {
    const res = await fetch(`${BACKEND_URL}/api/v1/bio/pages/${bioId}/links/${linkId}`, {
      method: 'DELETE',
      headers: getAuthHeaders()
    });
    return res.json();
  },

  reorderLinks: async (bioId, linkIds) => {
    const res = await fetch(`${BACKEND_URL}/api/v1/bio/pages/${bioId}/links/reorder`, {
      method: 'PUT',
      headers: getAuthHeaders(),
      body: JSON.stringify(linkIds)
    });
    return res.json();
  },

  // Analytics
  getAnalytics: async (bioId, days = 30) => {
    const res = await fetch(`${BACKEND_URL}/api/v1/bio/pages/${bioId}/analytics?days=${days}`, {
      headers: getAuthHeaders()
    });
    return res.json();
  },

  // Public
  getPublic: async (slug) => {
    const res = await fetch(`${BACKEND_URL}/api/v1/bio/public/${slug}`);
    return res.json();
  }
};
